import useActionsConnectAccountForm from './useActionsConnectAccountForm'

export default useActionsConnectAccountForm
